import { render, staticRenderFns } from "./TsIPagination.vue?vue&type=template&id=3bc0cfa8&"
import script from "./TsIPagination.vue?vue&type=script&lang=js&"
export * from "./TsIPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports